"use strict";
// @ts-nocheck
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
exports.__esModule = true;
var React = __importStar(require("react"));
;
function atm(_a) {
    var size = _a.size, _b = _a.color, color = _b === void 0 ? "currentColor" : _b;
    return React.createElement("svg", { width: size, height: size, viewBox: "0 0 24 24", fill: "none" },
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M15.1927 14.2064L15.9097 15.5542C16.3175 16.3214 16.4039 17.2192 16.1499 18.0502C15.8959 18.8811 15.3223 19.5771 14.5552 19.9852L14.4622 20.0347C14.0822 20.2368 13.6662 20.362 13.2379 20.4033C12.8096 20.4446 12.3773 20.4011 11.9658 20.2753C11.5542 20.1495 11.1715 19.9439 10.8394 19.6702C10.5074 19.3966 10.2325 19.0601 10.0304 18.6802L7.61317 14.1337C7.22016 13.3946 7.1249 12.5332 7.34693 11.7261C7.56896 10.919 8.09144 10.2275 8.80717 9.79345L8.09017 8.4457C7.68238 7.67838 7.59607 6.7805 7.85022 5.94955C8.10437 5.1186 8.67817 4.42262 9.44542 4.0147L9.53842 3.9652C10.3057 3.55735 11.2035 3.47092 12.0344 3.72493C12.8653 3.97894 13.5614 4.55258 13.9694 5.3197L16.3867 9.8662C16.7797 10.6052 16.8751 11.4666 16.6532 12.2736C16.4314 13.0807 15.909 13.7723 15.1934 14.2064H15.1927ZM15.1927 14.2064L13.4924 11.0077C13.0844 10.2406 12.3883 9.66694 11.5574 9.41293C10.7265 9.15892 9.82865 9.24535 9.06142 9.6532L8.96842 9.70195C8.91367 9.73195 8.85967 9.76195 8.80717 9.79345L10.5082 12.9922C10.9162 13.7593 11.6123 14.333 12.4432 14.587C13.2741 14.841 14.1719 14.7545 14.9392 14.3467L15.0322 14.2979C15.0869 14.2679 15.1409 14.2379 15.1934 14.2064H15.1927Z", fill: color }));
}
exports["default"] = atm;
//# sourceMappingURL=atm.js.map